import React, { useEffect, useState } from "react";
import { Avatar, Col, Divider, Modal, Row } from "antd";
import { Table } from "antd/lib";
import styled from "styled-components";
import { InfoCircleOutlined } from "@ant-design/icons";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import image from "../../../resource/image";
import Text from "../../../components/Text/Text";
import color from "../../../resource/color";
import { numberFormatter } from "../../../utility/Formatter";

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    padding: 0;
  }
  .ant-modal-body {
    padding: 0;
  }
`;
const TableWrapper = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 24px 24px 24px;
`;
interface Props {
  visible: boolean;
  onCancel: () => void;
  products: any[];
  cusName?: string;
}

function ModalCheckProductDup({ visible, onCancel, products, cusName }: Props) {
  const columns = [
    {
      title: <span>ชื่อสินค้า</span>,
      dataIndex: "productName",
      width: "40%",
      render: (text: string, value: any, index: any) => {
        return (
          <FlexRow align='center'>
            <div style={{ marginRight: 16 }}>
              <Avatar
                src={
                  value.productImage === "No" ||
                  value.productImage === "" ||
                  value.productImage === null
                    ? image.product_no_image
                    : value.productImage || value.productFreebiesImage
                }
                size={50}
                shape='square'
                onError={() => false}
              />
            </div>
            <FlexCol>
              <div style={{ height: 25, textOverflow: "ellipsis" }}>
                <Text level={5}>{value.productName}</Text>
              </div>
              {value.commonName && (
                <div style={{ height: 25, textOverflow: "ellipsis" }}>
                  <Text level={6} style={{ color: color.Grey }}>
                    {value.commonName}
                  </Text>
                </div>
              )}
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  Product Group : {value.productGroup}
                </Text>
              </div>
              {value.productStrategy && (
                <div style={{ height: 25 }}>
                  <Text level={6} style={{ color: color.Grey }}>
                    Strategy Group : {value.productStrategy}
                  </Text>
                </div>
              )}
            </FlexCol>
          </FlexRow>
        );
      },
    },
    {
      title: <span>Product Code</span>,
      dataIndex: "productCodeNAV",
      width: "20%",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25 }}>
              <Text level={5}>{value.productCodeNAV}</Text>
            </div>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={6} style={{ color: color.Grey }}>
                Pack Size : {value.packSize}
              </Text>
            </div>
          </FlexCol>
        </FlexRow>
      ),
    },
  ];

  return (
    <ModalStyled
      centered
      open={visible}
      onCancel={onCancel}
      maskClosable={true}
      width={750}
      footer={false}
    >
      <div
        style={{
          padding: "24px 24px 0px 24px ",
        }}
      >
        <Text align='left' fontWeight={700} fontSize={18}>
          สินค้าที่ไม่มีจำหน่ายในร้าน ({numberFormatter(products.length, 0)})
        </Text>
        <br />
        <Text align='left' fontWeight={400} fontSize={16}>
          {cusName}
        </Text>
        <Row
          gutter={20}
          style={{
            backgroundColor: "#FFF5F5",
            padding: "10px 0px 10px 0px",
            borderRadius: 4,
            width: "100%",
            margin: 0,
          }}
        >
          <Col>
            <InfoCircleOutlined style={{ color: color.warning, fontSize: 20 }} />
          </Col>
          <Col span={22}>
            <Text align='left' fontWeight={400} fontSize={14} fontFamily='Sarabun'>
              สินค้าที่ร้านค้าไม่มีจำหน่ายในร้านจะไม่ได้รับโควตา
              ส่วนสินค้าอื่นที่มีจำหน่ายจะได้รับโควตาตามปกติ
            </Text>
          </Col>
        </Row>
      </div>
      <Divider style={{ marginBottom: "0px" }} />
      <TableWrapper>
        <Table showHeader={false} columns={columns} dataSource={products} pagination={false} />
      </TableWrapper>
    </ModalStyled>
  );
}

export default ModalCheckProductDup;
